var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnails__item photo"},[_c('img',{attrs:{"src":_vm.photo.img_preview,"alt":_vm.name + _vm.$t('shared.alts.photo')}})])}
var staticRenderFns = []

export { render, staticRenderFns }